import React from 'react';
import { Route, Switch } from 'react-router';
import Layout from 'components/Layout';
import List from './List';
import Form from './Form';

const Category = () => (
  <Layout>
    <Switch>
      <Route exact path="/categories" component={List} />
      <Route exact path="/categories/new" component={Form} />
      <Route exact path="/categories/:id" component={Form} />
    </Switch>
  </Layout>
);

export default Category;
